export default __webpack_public_path__ + "static/media/boxes.cfb3785f.png";